import { Tooltip } from "bootstrap";
import { type ReactElement, useEffect, useRef } from "react";

type Props = {
    title: string;
    html?: boolean;
    children: ReactElement;
}

export default function BootstrapTooltip(props: Props) {
    const ref = useRef<HTMLElement | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        const instance = new Tooltip(ref.current, {
            title: props.title,
            trigger: "hover focus",
            placement: "top",
            html: props.html ?? false,
        });

        return () => {
            instance.dispose();
        };
    }, [ props.title ]);

    return {
        ...props.children,
        ref,
        props: {
            ...(props.children.props ?? {}),
            "data-bs-toggle": "tooltip"
        }
    };
}
